/**
 * FrontendConfig models configuration for frontend widget
 */
class FrontendConfig {
    startFormRequireMail = true;
    startFormRequireConsent = true;
    startFormConsentLink = null;
    windowOpenOnInit = false;
    translations = new Translations();
    displaySizing = new DisplaySizing();

    /**
     * @returns {object}
     */
    toJson() {
        return {
            startFormRequireMail: this.startFormRequireMail,
            startFormRequireConsent: this.startFormRequireConsent,
            startFormConsentLink: this.startFormConsentLink,
            windowOpenOnInit: this.windowOpenOnInit,
            translations: this.translations.toJson(),
            displaySizing: this.displaySizing.toJson(),
        }
    }

    /**
     * @returns {Translations}
     */
    getTranslations() {
        return this.translations;
    }

    /**
     * @returns {DisplaySizing}
     */
    getDisplaySizing() {
        return this.displaySizing;
    }

    /**
     * @param data
     * @returns {FrontendConfig}
     */
    static fromJson(data) {
        if (typeof data.translations !== 'undefined') {
            data.translations = Translations.fromJson(data.translations);
        }

        if (typeof data.displaySizing !== 'undefined') {
            data.displaySizing = DisplaySizing.fromJson(data.displaySizing);
        }

        return Object.assign(new FrontendConfig(), data);
    }
}

/**
 * Translations models all needed frontend translations
 */
class Translations {
    windowHeadline = 'Chat';

    // default is empty so inside label isn't shown
    actionBtnLabel = '';

    startFormMailLabel = 'E-Mail';
    startFormNameLabel = 'Name';
    startFormEnterButton = 'Start Chat';

    // Use "{link}Label{link}" to indicate were FrontendConfig.startFormConsentLink should be placed
    startFormConsentLabel = 'Ich stimme unseren Datenschutzrichtlinien zu.';

    // Can be "null" to disable message
    resumeMismatchMessage = 'Für diese URL gibt es einen anderen Ansprechpartner.';
    resumeMismatchStartNewLabel = 'Chat beenden & mit neuem Ansprechpartner starten';
    resumeMismatchKeepOldLabel = 'Chat fortführen';

    /**
     * @returns {object}
     */
    toJson() {
        return {
            windowHeadline:              this.windowHeadline,
            actionBtnLabel:              this.actionBtnLabel,
            startFormConsentLabel:       this.startFormConsentLabel,
            startFormMailLabel:          this.startFormMailLabel,
            startFormNameLabel:          this.startFormNameLabel,
            startFormEnterButton:        this.startFormEnterButton,
            resumeMismatchMessage:       this.resumeMismatchMessage,
            resumeMismatchStartNewLabel: this.resumeMismatchStartNewLabel,
            resumeMismatchKeepOldLabel:  this.resumeMismatchKeepOldLabel
        };
    }

    /**
     * @param data
     * @returns {Translations}
     */
    static fromJson(data) {
        return Object.assign(new Translations(), data);
    }
}

class DisplaySizing {
    actionButtonHeight = 50;
    actionButtonWidth = 50;
    windowHeight = 600;
    windowWidth = 350;
    addedMargin = 10;

    /**
     * @returns {object}
     */
    toJson() {
        return {
            actionButtonHeight: this.actionButtonHeight,
            actionButtonWidth:  this.actionButtonWidth,
            windowHeight:       this.windowHeight,
            windowWidth:        this.windowWidth,
            addedMargin:        this.addedMargin,
        };
    }

    /**
     * @param data
     * @returns {DisplaySizing}
     */
    static fromJson(data) {
        return Object.assign(new DisplaySizing(), data);
    }
}

module.exports.FrontendConfig = FrontendConfig;
module.exports.Translations   = Translations;
module.exports.DisplaySizing  = DisplaySizing;